/** @module ProductSpec/SizeChart/NewFromSizeChartDimensions */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/xml",
	"csi/xml/Query",
	"csi/action/FormData",
	"csi/reflection",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin"
], function(declare,lang,_,xml,Query,FormData,reflection,NewFrom,ActionControllerMixin) {

	var SELECT_SIZE_CHART = 0;
	var SELECT_SIZE_CHART_DIMENSIONS = 1;

	return declare([NewFrom, ActionControllerMixin], {
		_fdSizeChart: null,
		_fdSCLines: null,
		_thisSizeChart: null,
		_thisSizeChartRev: null,

		preProcess: function() {
			this._thisSizeChartRev = this.getParent();
			this._thisSizeChart = this.getCache().getNode(this._thisSizeChartRev.__Parent__);

			this._fdSizeChart = this.getFormData();
			this._fdSizeChart.m_bSelectOne = true;
			this._fdSizeChart.m_bRequireOne = true;

			this._fdSCLines = new FormData(this);
			this._fdSCLines.m_bRequireOne = true;

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Disable Finish button when there is no selected value
		 */
		disableFinish: function(wizard, page, index) {
			return !page.getPageData().hasSelections();
		},

		/**
		 * @override
		 * Disable Next button when there is no selected value
		 */
		disableNext: function(wizard, page, index) {
			return !page.getPageData().hasSelections();
		},

		/**
		 * Return Query filter for the "Select Size Chart" page
		 */
		getWizardViewQuery: function(wizard, view, index) {
			var q;

			if (index == SELECT_SIZE_CHART) {
			    var sizes = this._thisSizeChartRev.Sizes;

			    q = new Query()
			    	// Only other SizeChart can be selected
			    	.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, this._thisSizeChartRev.__Parent__);

			    // Shape size charts linked to the current size chart should be filtered out
			    var urlShapeSizeChart = this._thisSizeChart.ShapeSizeChart;
			    if (xml.isValidURL(urlShapeSizeChart)) {
			    	q = q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, urlShapeSizeChart);
			    }
			}

			return q;
		},

		/**
		 * Prepare the data and pass it into the next page
		 */
		onNextPage: function(wizard, currentPage, nextPage, bFinish) {
			var	nPage = wizard.getIndexOfPage(nextPage);
			var	fd;
			var	bRefresh = false;

			switch (nPage) {
				case SELECT_SIZE_CHART:
					fd = this._fdSizeChart;

					break;

				case SELECT_SIZE_CHART_DIMENSIONS:
					this.fromSizeChart = this.m_formData.getSelectedNode();

					fd = this._fdSCLines;

					// if form data node has changed, then reset selections and refresh view
					if (fd.getNode() != this.fromSizeChart) {
						fd.resetSelections();
						fd.setNode(this.fromSizeChart);
						bRefresh = true;
					}

					break;
			}

			return fd ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		/**
		 * Send selected Items as parameter
		 */
		toWriterRequest: function() {
			var	call = this.inherited(arguments);
			if (call) {
				this.toWriterSelections(this._fdSCLines, call, null);
			}

			return call;
		}
	});
});